import styled from 'styled-components';

export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 10000;

  opacity: 1;
  animation: modalBounce 0.15s ease-in-out;

  @keyframes modalBounce {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;

  background-color: ${({ theme }) => theme.palette.white};
  transform: translate(-50%, -50%);
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.3);
  transition: all 0.3s;
  z-index: 15;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  padding: 12px 16px;
  border: 1px solid ${({ theme }) => theme.palette.D30};

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    max-width: 800px;
    max-height: 400px;
    padding: 40px 40px 52px 40px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
`;

export const Main = styled.div`
  display: flex;
  gap: 12px;
  flex-direction: column;
  overflow: hidden;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-direction: row;
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  width: 100%;
  display: flex;
  justify-content: center;
  height: fit-content;

  & img {
    border-radius: 8px;
  }

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 200px;
  }
`;

export const ContentWrapper = styled.div`
  flex: 1;
  height: 100%;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 5px;
  }
  /* Track */
  &::-webkit-scrollbar-track {
    background-color: ${({ theme }) => theme.palette.NL30};
    border-radius: 10px;
  }
  /* Handle */
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.palette.NL100};
    border-radius: 10px;
  }
`;

export const FlexDatesWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const SingleDateWrapper = styled.div`
  width: fit-content;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.NL20};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  margin-bottom: 24px;
`;
